import { render, staticRenderFns } from "./DiagramVca.vue?vue&type=template&id=1944e9ec&scoped=true"
import script from "./DiagramVca.vue?vue&type=script&lang=ts"
export * from "./DiagramVca.vue?vue&type=script&lang=ts"
import style0 from "./DiagramVca.vue?vue&type=style&index=0&id=1944e9ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1944e9ec",
  null
  
)

export default component.exports